import type { FaireProductEntity } from "../../entity_types/product";

export const p_tumgubh6yp: FaireProductEntity = {
  token: "p_tumgubh6yp",
  type: "product",
  name: "Mindfulness Magic Ball",
  brandToken: "b_pt47qddvxc",
  brandName: "Mindful and Co Kids USA",
  imageUrl:
    "https://cdn.faire.com/fastly/593575b4f565294e5f6901d1c72a93050b1dc51d38d766aa848bb4365a568492.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/47efb3cfd2aeef73f058483b2ecc85c7ccf7ef04b6852a156ce2feaec54c0292.png",
    "https://cdn.faire.com/fastly/add46851f41520a803933a3cc158843e02955c7938ad5dfc55afb514c2bb7d4f.png",
    "https://cdn.faire.com/fastly/52a990f9aad8d231d8b37cbbbdd76490e0eae4d23d07ea5aee6954ef64367473.png",
    "https://cdn.faire.com/fastly/a35ffd94c6ba5d7b41edf963a78a3ccf1f9740261e8853f8610d811c5b85b267.png",
    "https://cdn.faire.com/fastly/0cde53d9a8cdcde5dca6bb9b63e612aa6be8ed52ce70ba92c8043286d03c7e5c.png",
  ],
  priceDollars: 10,
  description:
    "Introducing our Mindfulness Magic Ball - a perfect toy for kids to cultivate mindfulness and relaxation! Also known as the Hoberman Sphere, this expandable ball teaches mindful breathing techniques.\n\nDesigned with a calming color palette, the ball engages children in mindfulness practice. Suitable for homes, classrooms, and daycare centers, ideal for kids aged 3+.\n\nFeatures:\n\nEncourages mindfulness and focus.\nDemonstrates lung and breath movements.\nExpandable with moving parts.\nEnhances emotional awareness.\nIdeal for back-to-school and baby gifts.\nPromotes relaxation and reduces stress.\n\nBring the magic of mindfulness to your little ones with our Mindfulness Magic Ball - a must-have kids' toy! Shop now for a calming experience.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:12.754Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
